/* globals COMMITHASH */

module.exports = COMMITHASH;
